if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						rule = this.getAttribute('data-qty-rule') || 'normal',
						qtyMin = rule === 'cakepopset' || rule === 'madetoorder' ? 6 : 1,
						qtyStep = rule === 'cakepopset' ? 6 : 1,
						qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

			qty.value = parseInt(qty.value) < qtyMin ? qtyMin : parseInt(qty.value);
			qty.setAttribute('min', qtyMin);
			qty.setAttribute('step', qtyStep);

			const updateButtons = () => {
				const currentQty = parseInt(qty.value) || qtyMin;

				qtyMinus.classList.toggle('disabled', currentQty - qtyStep < qtyMin);
				qtyPlus.classList.toggle('disabled', currentQty + qtyStep > qtyMax);
			};

			const cleanQty = () => {
				let currentQty = parseInt(qty.value) || qtyMin;

				if ( currentQty < qtyMin ) currentQty = qtyMin;

				if ( rule === 'cakepopset' ) {
					currentQty = Math.ceil(currentQty / 6) * 6;
				}

				if ( currentQty > qtyMax ) currentQty = qtyMax;

				qty.value = currentQty;
				updateButtons();
			};

			cleanQty();

			qty.addEventListener('change', cleanQty);

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();

				if ( ! qtyMinus.classList.contains('disabled') ) {
					qty.value = (parseInt(qty.value) || qtyMin) - qtyStep;
					cleanQty();
				}
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();

				if ( ! qtyPlus.classList.contains('disabled') ) {
					qty.value = (parseInt(qty.value) || qtyMin) + qtyStep;
					cleanQty();
				}
			});

		}
	}

	if ( typeof customElements.get('product-quantity') == 'undefined' ) {
		customElements.define('product-quantity', ProductQuantity);
	}
}